import React from 'react';
import { useConnectAccount, useProfile } from '@/hooks';
import { Providers } from '@/types/providers.type';
import { ConnectionButton } from '@/views/settings/connections/Connect.button';
import { stringMask } from '@/utils';
import { useTranslation } from 'react-i18next';
import { useProviderAccount } from '@/hooks/useProviderAccount';
import classNames from 'classnames';

export type ConnectionProps = {
  provider: Providers;
  icon?: string;
  title: string;
  description: string;
  account?: string | null;
};

export function ConnectionWidget({ provider, icon, title, description, account }: ConnectionProps) {
  const { t } = useTranslation();

  const {
    profile: { id = '' },
  } = useProfile();

  const { account: accountData } = useProviderAccount(provider);

  const { connect, disconnect, isConnected } = useConnectAccount(id);

  return (
    <div className='px-2 flex-auto w-full md:basis-1/2 md:max-w-[50%] xl:basis-1/3 xl:max-w-[33.3%]'>
      <div
        className={classNames(
          'flex flex-col p-4 rounded-md border',
          isConnected(provider)
            ? 'border-gray-400 dark:border-transparent bg-blue-50 dark:bg-yellow-500/20 dark:text-white'
            : 'border-gray-300 dark:border-[#FFDA68] text-gray-500 dark:text-white',
        )}
      >
        <div className='flex justify-between items-start'>
          <div className='flex flex-col grow gap-y-2'>
            {/*<img src={metamask} className='w-8 h-8' alt='metamask' />*/}
            <i className={`icon-${icon || provider} text-2xl`} />
            <h4 className='text-base leading-6 font-medium'>{title}</h4>
          </div>
          <ConnectionButton
            isConnected={isConnected(provider)}
            onConnect={connect[provider]}
            onDisconnect={disconnect[provider]}
          />
        </div>
        <p className='max-h-16 h-16 text-sm leading-5 font-normal text-gray-500 dark:text-white/70 mt-2'>
          {description}
        </p>
        <div className='w-full text-sm leading-5 font-medium mt-2'>
          {t('ID:')} {accountData ? stringMask(String(accountData?.identity)) : '-'}
        </div>
      </div>
    </div>
  );
}
